import { Col, Row } from "antd";
import { CloseOutlined, CheckOutlined } from "@ant-design/icons";
import "./style.css";
import { useTranslation } from "react-i18next";
type checkprops = {
  password: boolean;
  capital: boolean;
  number: boolean;
  special: boolean;
  space: boolean;
  checkedPassword: boolean;
  allTrue: boolean;
  mustinclude?: boolean;
};
export const CheckPassword = ({
  password,
  capital,
  number,
  special,
  space,
  checkedPassword,
  allTrue,
  mustinclude,
}: checkprops) => {
  const [t] = useTranslation("common");
  return (
    <Row
      className={
        allTrue && checkedPassword
          ? "password-details correct"
          : "password-details incorrect"
      }
    >
      <Col>
        <Col style={{ color: "black" }}>
          {mustinclude ? (
            <CheckOutlined
              style={{ fontSize: "16px" }}
              className="check-mark"
            />
          ) : (
            <CloseOutlined style={{ fontSize: "16px" }} className="x-mark" />
          )}
          <span style={{ fontSize: "16px" }}>
            {" "}
            {t("password-must-include")}:{" "}
          </span>
        </Col>
        <Col offset={1}>
          {password ? (
            <CheckOutlined
              style={{ fontSize: "16px" }}
              className="check-mark"
            />
          ) : (
            <CloseOutlined style={{ fontSize: "16px" }} className="x-mark" />
          )}
          {t("8-20-characters")}
        </Col>
        <Col offset={1}>
          {capital ? (
            <CheckOutlined
              style={{ fontSize: "16px" }}
              className="check-mark"
            />
          ) : (
            <CloseOutlined style={{ fontSize: "16px" }} className="x-mark" />
          )}
          {t("at-least-one-capital-letter")}
        </Col>
        <Col offset={1}>
          {number ? (
            <CheckOutlined
              style={{ fontSize: "16px" }}
              className="check-mark"
            />
          ) : (
            <CloseOutlined style={{ fontSize: "16px" }} className="x-mark" />
          )}
          {t("at-least-one-number")}
        </Col>
        <Col offset={1}>
          {special ? (
            <CheckOutlined
              style={{ fontSize: "16px" }}
              className="check-mark"
            />
          ) : (
            <CloseOutlined style={{ fontSize: "16px" }} className="x-mark" />
          )}
          {t("at-least-one-special-character")}
        </Col>
        <Col offset={1}>
          {space ? (
            <CheckOutlined
              style={{ fontSize: "16px" }}
              className="check-mark"
            />
          ) : (
            <CloseOutlined style={{ fontSize: "16px" }} className="x-mark" />
          )}
          {t("no-spaces")}
        </Col>
        <Col offset={1}>
          {checkedPassword ? (
            <CheckOutlined
              style={{ fontSize: "16px" }}
              className="check-mark"
            />
          ) : (
            <CloseOutlined style={{ fontSize: "16px" }} className="x-mark" />
          )}
          {t("passwords-matched")}
        </Col>
      </Col>
    </Row>
  );
};
